var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 26,
    fill: "none",
    viewBox: "0 0 27 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#142C48",
    fillRule: "evenodd",
    d: "M13.5.333C6.133.333.167 6.07.167 13.15c0 5.67 3.816 10.46 9.116 12.159.667.112.917-.272.917-.609 0-.304-.017-1.313-.017-2.387-3.35.593-4.216-.785-4.483-1.506-.15-.368-.8-1.506-1.367-1.81-.466-.24-1.133-.833-.016-.849 1.05-.016 1.8.93 2.05 1.314 1.2 1.938 3.116 1.393 3.883 1.057.117-.833.467-1.394.85-1.714-2.967-.32-6.067-1.426-6.067-6.328 0-1.394.517-2.547 1.367-3.445-.133-.32-.6-1.634.133-3.396 0 0 1.117-.336 3.667 1.314a12.84 12.84 0 0 1 3.333-.433c1.134 0 2.267.144 3.334.433 2.55-1.666 3.666-1.314 3.666-1.314.734 1.762.267 3.076.134 3.396.85.898 1.366 2.035 1.366 3.445 0 4.918-3.116 6.007-6.083 6.328.483.4.9 1.17.9 2.37 0 1.715-.017 3.093-.017 3.525 0 .337.25.737.917.609 2.647-.859 4.947-2.494 6.576-4.675a12.502 12.502 0 0 0 2.507-7.484C26.833 6.069 20.867.333 13.5.333Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.8cec01579ae0421efd723c436e002d0c.svg";
export { ForwardRef as ReactComponent };